import { createSelector } from 'reselect';

export const getVisualizationsLoaded = (state) => state.visualizations.siteLoaded;

export const getMappedVisualizations = (state) => state.visualizations.visualizations;

export const getVisualizations = createSelector(getMappedVisualizations, (visualizations) =>
  Object.values(visualizations)
);

export const getVisualizationSubscriptions = (state) => state.visualizations.subscriptions;

export const getVisualizationValues = (state) => state.visualizations.values;

export const getVisualization = createSelector(
  getMappedVisualizations,
  (_, id) => id,
  (visualizations, id) => visualizations[id]
);

export const getVisualizationPanelValue = createSelector(
  getVisualizationValues,
  (_, visualizationId, panelId) => [visualizationId, panelId],
  (vizValues, [visualizationId, panelId]) =>
    vizValues[visualizationId]?.find((panelValues) => panelValues.panelId === panelId)
);
